import React from 'react';

import { Display, Flex, Paragraph, Text } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import { Props as FlexProps } from '@rover/kibble/core/Flex';
import { Props as ParagraphProps } from '@rover/kibble/core/Paragraph';
import { Props as TextProps } from '@rover/kibble/core/Text';
import UnorderedList from '@rover/react-lib/src/components/lists/UnorderedList/UnorderedList';

type UnorderedListProps = React.ComponentProps<typeof UnorderedList>;

const ServiceTargetAudience = ({ children, ...flexProps }: FlexProps): JSX.Element => (
  <Flex
    flexDirection="column"
    alignItems="center"
    width={['100%', '80%', '60%']}
    justifySelf="center"
    paddingX="4x" // intentional extra padding
    {...flexProps}
  >
    {children}
  </Flex>
);

ServiceTargetAudience.Content = ({ children, ...paragraphProps }: ParagraphProps): JSX.Element => {
  return (
    <Paragraph size="200" textAlign="center" {...paragraphProps}>
      {children}
    </Paragraph>
  );
};

ServiceTargetAudience.List = ({ children, ...ulProps }: UnorderedListProps): JSX.Element => {
  return (
    <UnorderedList paddingLeft="4x" {...ulProps}>
      {children}
    </UnorderedList>
  );
};

ServiceTargetAudience.Display = (props: DisplayProps): JSX.Element => {
  return (
    <Display size="500" webProps={{ responsive: false, as: 'h3' }} textAlign="center" {...props}>
      {props.children}
    </Display>
  );
};

ServiceTargetAudience.ListItem = (props: TextProps): JSX.Element => {
  return (
    <Text size="200" {...props}>
      {props.children}
    </Text>
  );
};

export default ServiceTargetAudience;
